module.exports = __webpack_public_path__ + "portal/static/img/kiatnakin.04298f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon-bank/kiatnakin.png
// module id = l84f
// module chunks = 67